import { AppEventSdk } from '@sxm-de/dev-kits/web-sdk/types';

export function trackBusinessError(
    appEventSdk: AppEventSdk,
    error: {
        code: string;
        message: string;
    },
) {
    appEventSdk.trackEvent({
        event: 'business-error',
        errors: [
            {
                errorType: 'BUSINESS',
                errorName: error.message,
                errorCode: error.code,
            },
        ],
    });
}
